import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import enclomipheneInitialQuestions from './intial/questions';
import enclomipheneFollowupQuestions from './followup/questions';

const EnclomipheneQuestions = [
  ...enclomipheneInitialQuestions,
  ...enclomipheneFollowupQuestions
];
export default EnclomipheneQuestions;

export type EnclomipheneQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof EnclomipheneQuestions>
>;
export type EnclomipheneFollowupQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof enclomipheneFollowupQuestions>
>;
